import { isIE } from './isIE';
import { isLegacyEdge } from './isLegacyEdge';

/**
 * Returns true if the current browser is a legacy browser (IE or pre-Chromium Edge).
 */
export const isLegacyBrowser = () => {
    return isIE() || isLegacyEdge();
};
